// Mapping of ISO 3166-1 alpha-2 codes to CountryName
export const CountryEnum = {
	AT: 'Österreich',
	AD: 'Andorra',
	AL: 'Albanien',
	BA: 'Bosnien und Herzegowina',
	BE: 'Belgien',
	BG: 'Bulgarien',
	CH: 'Schweiz',
	CY: 'Zypern',
	CZ: 'Tschechien',
	DE: 'Deutschland',
	DK: 'Dänemark',
	EE: 'Estland',
	ES: 'Spanien',
	FI: 'Finnland',
	FR: 'Frankreich',
	GB: 'Großbritannien',
	GR: 'Griechenland',
	HR: 'Kroatien',
	HU: 'Ungarn',
	IE: 'Irland',
	IS: 'Island',
	IT: 'Italien',
	LI: 'Liechtenstein',
	LT: 'Litauen',
	LU: 'Luxemburg',
	LV: 'Lettland',
	MC: 'Monaco',
	MD: 'Moldawien',
	ME: 'Montenegro',
	MK: 'Nordmazedonien',
	MT: 'Malta',
	NL: 'Niederlande',
	NO: 'Norwegen',
	PL: 'Polen',
	PT: 'Portugal',
	RO: 'Rumänien',
	RS: 'Serbien',
	SE: 'Schweden',
	SI: 'Slowenien',
	SK: 'Slowakei',
	SM: 'San Marino',
	TR: 'Türkei',
	UA: 'Ukraine',
	VA: 'Vatikan',
};

export default CountryEnum;
